import { useEffect, useRef } from 'react';
import { updateEnergy } from '@redux/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { calculateEnergy } from '@shared-libs/energy';

import { useSelectorRef } from './selector-ref';

const useEnergyRecovery = (): void => {
  const energy = useAppSelector((state) => state.user.extendedInfo?.energy);
  const lastEnergyUpdated = useAppSelector(
    (state) => state.user.extendedInfo?.lastEnergyUpdated,
  );
  const energyIncreasePerHour = useAppSelector(
    (state) => state.user.user?.settings.energyIncreasePerHour,
  );
  const energyRef = useSelectorRef((state) => state.user.extendedInfo?.energy);
  const dispatch = useAppDispatch();
  const ref = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    if (lastEnergyUpdated && energyIncreasePerHour) {
      const increaseEnergy = () => {
        let lastUpdate = new Date();

        return (): void => {
          const newEnergy = calculateEnergy(
            energyRef.current || 0,
            energyIncreasePerHour,
            lastUpdate,
            1000,
          );

          if (newEnergy !== energyRef.current) {
            console.log('change Energy', newEnergy);
            dispatch(updateEnergy(newEnergy));
            lastUpdate = new Date();
          }
        };
      };

      ref.current = setInterval(increaseEnergy(), 1000);
    }

    return (): void => {
      clearInterval(ref.current);
    };
  }, [lastEnergyUpdated, energyIncreasePerHour]);

  useEffect(() => {
    if (energy && energy >= 1000) {
      clearInterval(ref.current);
    }
  }, [energy]);
};

export { useEnergyRecovery };
